// components

// react
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";

// css
import './notiLog_mobile.css';
import styles from './notiLog_mobile.module.css';
import { getNotificationListOne } from '../../../service/pushService';
import NotiLogDetailItemMobile from './notiLogDetailItem_mobile';

// services

function NotiLogDetailMobile({conn}) {

  const history = useHistory();
  const location = useLocation();

  const [dataState, setDataState] = useState({
    cid: location.state.cid,
    userId: location.state.userId,
  })

  const [dataSource, setDataSource] = useState({
    data: [],
  })

  const getData = () => {
    getNotificationListOne(conn, dataState)
    .then((response) => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.data = response;
        return item;
      })
    })
    .catch((err) => {
      console.log("err = ", err);
    })
  }
  useEffect(() => {
    getData();
  },[])

  return (
   <div class="pageContent_m">
     {dataSource.data.length ? (
        dataSource.data.map(item => {
          return <NotiLogDetailItemMobile conn={conn} item={item} />;
        })
      ) : (
        <div></div>
      )}
   </div>
  );
}

export default NotiLogDetailMobile;
